module.exports = __webpack_public_path__ + "static/Pt12-7958c61d49dfd531b28fb6d237de8994.jpg";